import { render, staticRenderFns } from "./DeleteRelationImport.vue?vue&type=template&id=39e2d9ba"
import script from "./DeleteRelationImport.vue?vue&type=script&lang=js"
export * from "./DeleteRelationImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports